import React from 'react';
import moment from 'moment-timezone'
import {calcWorstReceiver} from './BudgetView'
import _ from 'lodash'
import Load from '../../components/Load'

export const colours = {
    safe: {
        c: "#5aa927",
        value: 0.0,
        text: 'SAFE'
    },
    warning: {
        c: "#cc9900",
        value: 0.8,
        text: 'WARNING'
    },
    danger: {
        c: "#cc6600",
        value: 0.9,
        text: 'DANGER'
    },
    exceedance: {
        c: "red",
        value: 1.0,
        text: 'OVER LIMIT'
    }
}

export const statusColour = (remaining) => {
    let colour = colours.safe
    _.values(colours).forEach(c => {
        if (1.0 - remaining > c.value) {
            colour = c
        }
    })
    return colour
}

const BudgetStatus = ({budget}) => {

    let status = <Load />
    if ((budget || {}).budgets) {

        const {values} = calcWorstReceiver((budget || {}).budgets)
        const colour = statusColour(values.remaining)

        //console.log('worstReceiver', worstReceiver, 'values', values, 'values.remaining', values.remaining, 'c', colour)

        status = <div className="budget-status-indicator" style={{backgroundColor: colour.c}}>{colour.text}</div>
    }

    const time = `${moment().format('DD/MM/YYYY')} ${moment().format('HH:mm')}`

    return (
        <div className="budget-status">
            <div className="budget-status-header">Current Engine Testing Status</div>
            <div>{time}</div>
            {status}

        </div>
    );
}

export default BudgetStatus




// WEBPACK FOOTER //
// ./src/components/budget/BudgetStatus.jsx